var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar',{attrs:{"scrolledDown":!_vm.scrolledDown}}),_c('div',{staticClass:"splash"},[_c('div',{staticClass:"gradient-overlay"}),_c('Sketch')],1),_c('Hero'),_c('MainView',{attrs:{"scrolledDown":!_vm.scrolledDown}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }